import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import Footer from './components/Footer';
import './App.css';

// Route-based code splitting
const Home = lazy(() => import('./pages/Home'));
const ModelsListing = lazy(() => import('./pages/ModelsListing'));
const ModelProfile = lazy(() => import('./pages/ModelProfile'));
const About = lazy(() => import('./pages/About'));
const Contact = lazy(() => import('./pages/Contact'));
const BecomeAModel = lazy(() => import('./pages/BecomeAModel'));
const Blog = lazy(() => import('./pages/Blog'));
const BlogArticle = lazy(() => import('./pages/BlogArticle'));

function PageLoader() {
  return (
    <div className="page-loader" role="status" aria-label="Loading page">
      <div className="loading-shimmer" style={{ width: '100%', height: '300px' }} />
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="app-container">
          <a href="#main-content" className="skip-to-content">
            Skip to main content
          </a>

          <Header />

          <div className="app-wrapper">
            <Suspense fallback={<PageLoader />}>
              <Routes>
                {/* Home */}
                <Route path="/" element={<Home />} />

                {/* Women — Mainboard + New Faces */}
                <Route path="/women" element={<ModelsListing category="women" />} />
                <Route path="/women/new-faces" element={<ModelsListing category="newfaces" />} />
                <Route path="/women/new-faces/:id/:name" element={<ModelProfile category="newfaces" />} />
                <Route path="/women/:id/:name" element={<ModelProfile category="women" />} />

                {/* Men */}
                <Route path="/men" element={<ModelsListing category="men" />} />
                <Route path="/men/:id/:name" element={<ModelProfile category="men" />} />

                {/* Commercial */}
                <Route path="/commercial/:gender" element={<ModelsListing category="commercial" />} />
                <Route path="/commercial/:gender/:id/:name" element={<ModelProfile category="commercial" />} />

                {/* Blog */}
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogArticle />} />

                {/* Become a Model */}
                <Route path="/become-a-model" element={<BecomeAModel />} />

                {/* About & Contact */}
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />

                {/* 404 */}
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Suspense>
          </div>

          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

function NotFound() {
  return (
    <main className="not-found-page" id="main-content" style={{ textAlign: 'center', padding: '80px 20px' }}>
      <Helmet>
        <title>Page Not Found | D Model Management</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <h1 style={{ fontSize: '1.4rem', textTransform: 'uppercase', letterSpacing: '0.1em', color: '#666', marginBottom: '15px' }}>Page Not Found</h1>
      <p style={{ color: '#999', marginBottom: '20px' }}>The page you're looking for doesn't exist.</p>
      <a href="/" style={{ color: 'darkred', textTransform: 'uppercase', fontSize: '0.85rem', letterSpacing: '0.08em' }}>Back to Home</a>
    </main>
  );
}

export default App;
